export { daterange } from './daterangeComponent';

export { barchart } from './barchartComponent';
export { piechart } from './piechartComponent';

export { syncfusion_datepicker } from './syncfusion_datepicker';
export { syncfusion_dropdownlist } from './syncfusion_dropdownlist';
export { d } from './d';
export { s } from './s';
export { ms } from './ms';
export { t } from './t';
export { n } from './n';
export { numberwithmax } from './numberwithmax';
export { singlebuttongroup } from './singlebuttongroup';
export { radiobutton } from './radiobutton';
export { singleselect } from './singleselect';
export { dynamicsingleselect } from './dynamicsingleselect';
export { realradiobutton } from './realradiobutton';
export { multiselect } from './multiselect';
export { quantityButton } from './quantityButton';

export { default as dietCalculator } from './dietCalculator';

export { weightchart } from './weightChartComponent';
export { exercisePieChart } from './exercisePieChartComponent';
export { caloriesComparisonChart } from './caloriesComparisonChartComponent';
export { default as nutritionTargetComponent } from './nutritionTargetComponent';

export { quantityComponent as quantityComponent } from './quantityComponent';

export { default as debounce } from './debounce';

const he = require('he');
import { jsonrepair } from 'jsonrepair';

(window as any).he = he;

(window as any).jsonrepair = jsonrepair;

(window as any).parseJson = (str: string, skipRepair: boolean = false) => {
    if (str === '' || str === null || typeof (str) === undefined) {
        return null;
    }

    if (skipRepair) {
        return JSON.parse(he.decode(str));
    }

    return JSON.parse(jsonrepair(he.decode(str)));
};

(window as any).debounce = (func: Function, wait: number) => {
    let timeout: NodeJS.Timeout;
    return function (...args: any[]) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
};

// React dashboards
export * as HeartRate from './heartRateDashboard/components';

// DocsApp Puck components
export * as DocsApp from '@digitalopsdev/serviceops-docs-components';

// Shared Puck Activities components (used by MembersApp and CoachesApp)
export * as PuckActivities from './puck/activities';

// MacroPuck SSR and binding context (used by ReservationsApp editor and Server.Shared SSR)
export * from './MacroPuck/MacroBindingContext';
export * from './MacroPuck/MacroCollectionContext';
export { getMacroPuckConfig, MACRO_TYPES } from './MacroPuck/MacroPuckConfig';
export type { MacroRootProps } from './MacroPuck/MacroPuckConfig';
